module.exports = __webpack_public_path__ + "media/vendor_activation_email/logo-fc7e77d1.png";